/* =========================================================================
 * Public navbar routes.
 *
 * Note: the file is still called `consumerRoutes` for backwards-compat with
 * existing imports (DefaultNavbar, App.js getRoutes loop). After the 2026
 * redesign there's no consumer/account section, so these are just nav links
 * for the marketing site — no `component` / no `private` flag.
 *
 * Anchor hrefs (e.g. `/#how-it-works`) work when the browser is already on
 * `/` and section IDs are added to the homepage. They'll otherwise navigate
 * to `/` first.
 * ========================================================================= */

const consumerRoutes = [
  {
    name: "Researchers",
    key: "researchers",
    route: "/researchers",
  },
  {
    name: "Download",
    key: "download",
    // Relative hash — scrolls to whichever page has a #download section
    // (homepage + /researchers both do). On pages that don't, the link is
    // a no-op, which is acceptable since users navigate from `/` or
    // `/researchers` in practice.
    href: "#download",
  },
];

export default consumerRoutes;
